import type { ComponentType } from 'react'

import { createContext, useContext } from 'react'

interface FilterListOption {
  label: string
  value: string
}

export interface IssuerSearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder: string
  className: string
}

export interface FilterValueSources {
  formatOptionLabel: (fieldId: string, option: string) => string
  useFilterListOptions: (fieldId: string) => {
    options: FilterListOption[]
    isLoading: boolean
    isError: boolean
  }
  IssuerSearchInput: ComponentType<IssuerSearchInputProps>
}

const FilterValueSourcesContext = createContext<FilterValueSources | null>(null)

export const FilterValueSourcesProvider = FilterValueSourcesContext.Provider

export function useFilterValueSources(): FilterValueSources {
  const sources = useContext(FilterValueSourcesContext)
  if (!sources) {
    throw new Error('FilterBuilder needs a FilterValueSourcesProvider')
  }
  return sources
}
